import { useEffect } from 'react';
import { StrongBoxComplianceType } from '@nkr/enums/index';
import { IStrongBoxComplianceItem } from '@nkr/models/index';
import { Modal, Button, PanelGroup } from 'react-bootstrap';
import AddressCompliancePanel from './address-compliance-panel';
import PhysicalCompliancePanel from './physical-compliance-panel';

interface IProps {
    show: boolean,
    title: string,
    items: IStrongBoxComplianceItem[],
    isCenter: boolean,
    onItemResolved: (item: IStrongBoxComplianceItem) => void
    onClose: () => void
}

const StrongBoxToDoList = ({ show, title, items, isCenter, onClose, onItemResolved }: IProps) => {
    const handleClose = () => {
        onClose();
    };

    useEffect(() => {
        if (items.length == 0) {
            onClose();
        }
    }, [items])

    const panels = items.map((item) => {
        if (item.type == StrongBoxComplianceType.AddressConfirmation || item.type == StrongBoxComplianceType.AddressMissing || item.type == StrongBoxComplianceType.AddressMissingInformation) {
            return (
                <AddressCompliancePanel
                    item={item}
                    onItemResolved={onItemResolved}
                />
            );
        }

        if (item.type == StrongBoxComplianceType.PhysicalInventory) {
            return (
                <PhysicalCompliancePanel
                    item={item}
                    isCenter={isCenter}
                    onItemResolved={onItemResolved}
                />
            );
        }
    });

    return (
        <Modal show={show} bsSize='lg' backdrop='static' onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>{title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <PanelGroup>
                    {panels}
                </PanelGroup>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={handleClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default StrongBoxToDoList;